<template>
	<div class="inner-page user-page">
		<div class="user-main">
			<!-- <div class="font42 title">个人中心</div> -->
			<div class="user-infs" @click="goEdit">
				<div class="avator">
					<van-image fit="cover" :src="userInfs.avatar" class="img" @click.stop="previewAvator"></van-image>
				</div>

				<div class="user-base">
					<div class="user-name">{{ userInfs.username }}</div>
					<div class="user-num mCG">所在年级：{{ userInfs.grade }}</div>
				</div>
			</div>
			<div class="df-sb font28 wode">
				<div class="df-a" @click="goNext(0, '/creditHour','我的学分')">
					<img :src="icon1" alt="" />
					我的学分
				</div>
				<div class="df-a" @click="goNext(0, '/creditHour','我的芯币')">
					<img :src="icon2" alt=""  />
					我的芯币
				</div>
			</div>
		</div>

		<ul class="user-menu">
			<p class="font32">更多功能</p>
			<li
				:class="{ isLink: item.viewType != 2 }"
				v-for="(item, index) in menuData"
				:key="`b${index}`"
				@click="goNext(item.viewType, item.url)"
				class="df-sb"
			>
				<div class="df-sb df-a">
					<!-- <van-image class="icon" fit="cover" :src="item.icon"></van-image> -->
					<img :src="item.icon" alt="" class="icon">
					<div class="text">{{ item.text }}</div>
				</div>
				<div class="" v-if="item.text == '闯关模式'">
					<van-switch v-model="checked" @change="setmode" size="0.4rem" active-color="#FF7A32"/>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import { removeToken } from '@/utils/token';
import { setSourceUrl } from '@/utils/public';
export default {
	name: 'userPage',
	data() {
		return {
			avator: '',
			mainBg: require('@/assets/img/userBg.png'),
			icon1: require('@/assets/img/mine/icon-1.png'),
			icon2: require('@/assets/img/mine/icon-2.png'),
			checked: false,
			defaultId: 2000,
			menuData: [
				{
					icon: require('@/assets/img/mine/icon-3.png'),
					viewType: 0,
					text: '个人信息',
					url: '/userMessage'
				},
				{
					icon: require('@/assets/img/mine/icon-4.png'),
					text: '闯关模式',
					viewType: 3,
					url: '/errorBook'
				},
				{
					icon: require('@/assets/img/mine/icon-5.png'),
					text: '我的学习报告',
					viewType: 0,
					url: '/moreHistory'
				},
				{
					icon: require('@/assets/img/mine/icon-6.png'),
					viewType: 0,
					text: '我的礼品屋',
					url: '/house'
				},
				{
					icon: require('@/assets/img/mine/icon-7.png'),
					viewType: 0,
					text: '管理收货地址',
					url: '/giftAddress'
				},
				{
					icon: require('@/assets/icon/exit.png'),
					viewType: 2,
					text: '退出登录',
					url: ''
				}
			],
			userInfs:this.$store.getters['userCenter/getUserInfs']
		};
	},

	created() {
		this.checked = this.userInfs.mode == 0?false:true;
		// this.initUser();
		console.log(this.$store.getters['userCenter/getUserInfs'])
	},
	methods: {
		setSourceUrl,
		removeToken,
		setmode(type) {
			this.$api.setmode({mode:type?1:0}).then((res) => {
				if(res.code ==1){
					this.userInfs.mode = type?1:0;
					this.$store.commit('userCenter/setUserInfs', this.userInfs);
				}
		
			});
		},
		previewAvator() {
			this.$eventBus.$emit('showPreview', {
				handle: true,
				imgList: [this.userInfs.avatar]
			});
		},
		goEdit() {
			this.$router.push({
				path: '/editUser',
				query: {
					active: 2
				}
			});
		},
		goNext(type, url,title) {
			switch (type) {
				case 0: {
					if (url) {
						this.$router.push({
							path: url,
							query: {
								active: 2,
								title:title
							}
						});
					}
					break;
				}
				case 1: {
					if (url == 'server') {
						this.$eventBus.$emit('showServer', true);
					}
					break;
				}
				case 2: {
					this.$api.userSignout().then((res) => {
						if (res.code) {
							window.localStorage.clear();
							window.location.reload();
						}
					});
					break;
				}
				default:
					break;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.user-page {
	overflow-y: auto;
	bottom: 1rem;
	padding-bottom: 1rem;
}
.inner-page {
	background: #fff9f6;
	padding: 0.36rem 0.28rem 0;
}
.user-main {
	position: relative;
	width: 100%;
	.title {
		margin: 0.28rem 0 0.5rem 0;
	}
	.user-infs {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		margin-bottom: 0.42rem;
		.user-base {
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			.user-name {
				font-size: 0.36rem;
				font-weight: 500;
				margin-bottom: 0.1rem;
			}
			.user-num {
				font-size: 0.26rem;
				font-weight: 400;
			}
		}
		.avator {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 1.32rem;
			height: 1.31rem;
			border-radius: 50%;
			margin-right: 0.28rem;
			border: 0.05rem #fff solid;
			overflow: hidden;
			.img {
				width: 1.4rem;
				height: 1.4rem;
			}
		}
	}
	.wode {
		margin-bottom: 0.25rem;
		font-family: 'iconfont' !important;
		& > div {
			width: calc(50% - 0.12rem);
			border-radius: 0.1rem;
			height: 1rem;
			padding: 0 0.32rem;
			background: #fff;
			img {
				width: 0.42rem;
				margin-right: 0.2rem;
			}
			position: relative;
			&::before {
				position: absolute;
				right: 0.28rem;
				top: 50%;
				transform: translateY(-50%) rotate(180deg);
				content: '\e600';
				color: #909090;
			}
		}
	}
	.user-learning {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		left: 0.28rem;
		right: 0.28rem;
		bottom: 0;
		height: 1.98rem;
		padding: 0 0.48rem;
		background: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(160, 160, 160, 0.35);
		border-radius: 0.2rem;
		li {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			.num {
				font-weight: 400;
				color: #909090;
				font-size: 0.22rem;
				margin-bottom: 0.16rem;
				span {
					font-weight: 600;
					font-size: 0.42rem;
					color: #2db79a;
					padding: 0 0.05rem;
				}
			}
			.moudle {
				font-weight: 400;
				color: #909090;
				font-size: 0.24rem;
			}
		}
	}
}
.user-menu {
	background-color: #fff;
	border-radius: 0.1rem;
	padding: 0 0.3rem;
	.font32 {
		padding: 0.32rem 0;
	}
	li {
		display: flex;
		align-items: center;
		position: relative;
		padding: 0.25rem 0 0.28rem 0rem;
		font-size: 0.28rem;
		color: #333;
		height: 0.97rem;
		border-bottom: 1px #dcdcdc solid;
		font-family: 'iconfont' !important;
		font-size: 16px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		&:last-child{
			border: none;
		}
		&:active {
			background: rgba(0, 0, 0, 0.01);
		}
		.icon {
			display: flex;
			width: auto;
			height: 0.32rem;;
			margin-right: 0.22rem;
			
		}
		.text {
			font-size: 0.3rem;
		}
	}
	.isLink {
		&::before {
			position: absolute;
			right: 0rem;
			top: 50%;
			transform: translateY(-50%) rotate(180deg);
			content: '\e600';
			color: #909090;
		}
	}
}
.user-page {
	top: 0;
}
</style>
